import { MIGRATION_MANIFEST } from 'src/reducers/migrations/constants';
import { ReduxState } from 'src/store/types';

export type InitialData = { [s: string]: any };
export type PersistedData = Partial<ReduxState>;

const transformIds = Object.keys(MIGRATION_MANIFEST).map((_, idx) => idx);

/**
 * Performs migrations using the provided version. App state migrations
 * are already handled by redux-persist, so this is used for specific cases
 * like exporting/importing projects as zipped files
 */
export const migrate = (
  initial: InitialData,
  persistVersion: number
): PersistedData => {
  // push initial data through all transforms to higher versions
  const final = transformIds.reduce(
    (state: PersistedData, transformId: number) => {
      if (persistVersion >= transformId) {
        return state;
      }

      const transform = MIGRATION_MANIFEST[transformId];
      return transform(state);
    },
    initial
  );

  return final;
};
